export const i18nText: any = {
    us: {
        DELTA_PRO: {
            title: 'Recharge 80% on a 3 hour drive',
            desc: "Charge while you drive with the industry's first alternator charger innovation. With 800W turbo alternator, top up your energy storage 8 times faster than using a traditional car 12V outlet. Recharge 1kWh in only 1.3 hours. It's not just a faster charger, it maintains your battery health and works as a jump starter.",
            view_1: '<big>1.3 hours</big>to charge 1kWh',
            view_2_top: 'Turbocharge Alternator <big>800W</big>',
            view_2_bottom: 'Easy Installation',
            view_3_top_1: '8× Faster',
            view_3_top_2: 'EcoFlow Alternator Charger: 1.3 hr',
            view_3_top_3: 'Traditional 12V Car Outlets: 10 hr+',
            view_3_top_4: '*Comparison of time needed to fully charge 1kWh',
            view_3_bottom_left_1: '3-in-1',
            view_3_bottom_left_2: 'Fast Charger, Maintainer, and Jump Starter',
            view_3_bottom_right: 'App Smart Control',
        },
        DELTA_2_MAX: {
            title: 'Fully charge with a 2.6 hour drive',
            desc: "Charge while you drive with the industry's first alternator charger innovation. With 800W turbo alternator, top up your energy storage 8 times faster than using a traditional car 12V outlet. Recharge 1kWh in only 1.3 hours. It's not just a faster charger, it maintains your battery health and works as a jump starter.",
            view_1: '<big>1.3 hours</big>to charge 1kWh',
            view_2_top: 'Turbocharge Alternator <big>800W</big>',
            view_2_bottom: 'Easy Installation',
            view_3_top_1: '8× Faster',
            view_3_top_2: 'EcoFlow Alternator Charger: 1.3 hr',
            view_3_top_3: 'Traditional 12V Car Outlets: 10 hr+',
            view_3_top_4: '*Comparison of time needed to fully charge 1kWh',
            view_3_bottom_left_1: '3-in-1',
            view_3_bottom_left_2: 'Fast Charger, Maintainer, and Jump Starter',
            view_3_bottom_right: 'App Smart Control',
        },
        DELTA_2: {
            title: 'Fully charge with a 1.3 hour drive',
            desc: "Charge while you drive with the industry's first alternator charger innovation. With 800W turbo alternator, top up your energy storage 8 times faster than using a traditional car 12V outlet. Recharge 1kWh in only 1.3 hours. It's not just a faster charger, it maintains your battery health and works as a jump starter.",
            view_1: '<big>1.3 hours</big>to charge 1kWh',
            view_2_top: 'Turbocharge Alternator <big>800W</big>',
            view_2_bottom: 'Easy Installation',
            view_3_top_1: '8× Faster',
            view_3_top_2: 'EcoFlow Alternator Charger: 1.3 hr',
            view_3_top_3: 'Traditional 12V Car Outlets: 10 hr+',
            view_3_top_4: '*Comparison of time needed to fully charge 1kWh',
            view_3_bottom_left_1: '3-in-1',
            view_3_bottom_left_2: 'Fast Charger, Maintainer, and Jump Starter',
            view_3_bottom_right: 'App Smart Control',
        },
    },
    ca: {
        DELTA_PRO: {
            title: 'Recharge 80% on a 3 hour drive',
            desc: "Charge while you drive with the industry's first alternator charger innovation. With 800W turbo alternator, top up your energy storage 8 times faster than using a traditional car 12V outlet. Recharge 1kWh in only 1.3 hours. It's not just a faster charger, it maintains your battery health and works as a jump starter.",
            view_1: '<big>1.3 hours</big>to charge 1kWh',
            view_2_top: 'Turbocharge Alternator <big>800W</big>',
            view_2_bottom: 'Easy Installation',
            view_3_top_1: '8× Faster',
            view_3_top_2: 'EcoFlow Alternator Charger: 1.3 hr',
            view_3_top_3: 'Traditional 12V Car Outlets: 10 hr+',
            view_3_top_4: '*Comparison of time needed to fully charge 1kWh',
            view_3_bottom_left_1: '3-in-1',
            view_3_bottom_left_2: 'Fast Charger, Maintainer, and Jump Starter',
            view_3_bottom_right: 'App Smart Control',
        },
        DELTA_2_MAX: {
            title: 'Fully charge with a 2.6 hour drive',
            desc: "Charge while you drive with the industry's first alternator charger innovation. With 800W turbo alternator, top up your energy storage 8 times faster than using a traditional car 12V outlet. Recharge 1kWh in only 1.3 hours. It's not just a faster charger, it maintains your battery health and works as a jump starter.",
            view_1: '<big>1.3 hours</big>to charge 1kWh',
            view_2_top: 'Turbocharge Alternator <big>800W</big>',
            view_2_bottom: 'Easy Installation',
            view_3_top_1: '8× Faster',
            view_3_top_2: 'EcoFlow Alternator Charger: 1.3 hr',
            view_3_top_3: 'Traditional 12V Car Outlets: 10 hr+',
            view_3_top_4: '*Comparison of time needed to fully charge 1kWh',
            view_3_bottom_left_1: '3-in-1',
            view_3_bottom_left_2: 'Fast Charger, Maintainer, and Jump Starter',
            view_3_bottom_right: 'App Smart Control',
        },
        DELTA_2: {
            title: 'Fully charge with a 1.3 hour drive',
            desc: "Charge while you drive with the industry's first alternator charger innovation. With 800W turbo alternator, top up your energy storage 8 times faster than using a traditional car 12V outlet. Recharge 1kWh in only 1.3 hours. It's not just a faster charger, it maintains your battery health and works as a jump starter.",
            view_1: '<big>1.3 hours</big>to charge 1kWh',
            view_2_top: 'Turbocharge Alternator <big>800W</big>',
            view_2_bottom: 'Easy Installation',
            view_3_top_1: '8× Faster',
            view_3_top_2: 'EcoFlow Alternator Charger: 1.3 hr',
            view_3_top_3: 'Traditional 12V Car Outlets: 10 hr+',
            view_3_top_4: '*Comparison of time needed to fully charge 1kWh',
            view_3_bottom_left_1: '3-in-1',
            view_3_bottom_left_2: 'Fast Charger, Maintainer, and Jump Starter',
            view_3_bottom_right: 'App Smart Control',
        },
    },
    br: {
        DELTA_PRO: {
            title: 'Recarregue 80% em uma viagem de 3 horas',
            desc: 'Carregue enquanto dirige com a primeira inovação em carregadores de alternador do setor. Com um alternador turbo de 800 W, recarregue seu armazenamento de energia 8 vezes mais rápido do que usando uma tomada de 12 V tradicional. Recarregue 1 kWh em apenas 1,3 hora. Não é apenas um carregador mais rápido, ele mantém a saúde da bateria e funciona como um carregador auxiliar.',
            view_1: '<big>1,3 horas</big> para carregar 1 kWh',
            view_2_top: 'Alternador Turbocharge <big>800W</big>',
            view_2_bottom: 'Fácil instalação',
            view_3_top_1: '8× mais rápido',
            view_3_top_2: 'Carregador de alternador EcoFlow: 1,3 h',
            view_3_top_3: 'Tomadas tradicionais de 12 V para carros: 10 horas ou mais',
            view_3_top_4: '*Comparação do tempo necessário para carregar completamente 1 kWh',
            view_3_bottom_left_1: '3 em 1',
            view_3_bottom_left_2: 'Carregador rápido, mantenedor e auxiliar de partida',
            view_3_bottom_right: 'Controle Inteligente de Aplicativo',
        },
        DELTA_2_MAX: {
            title: 'Carregue totalmente com uma viagem de 2,6 horas',
            desc: 'Carregue enquanto dirige com a primeira inovação em carregadores de alternador do setor. Com um alternador turbo de 800 W, recarregue seu armazenamento de energia 8 vezes mais rápido do que usando uma tomada de 12 V tradicional. Recarregue 1 kWh em apenas 1,3 hora. Não é apenas um carregador mais rápido, ele mantém a saúde da bateria e funciona como um carregador auxiliar.',
            view_1: '<big>1,3 horas</big> para carregar 1 kWh',
            view_2_top: 'Alternador Turbocharge <big>800W</big>',
            view_2_bottom: 'Fácil instalação',
            view_3_top_1: '8× mais rápido',
            view_3_top_2: 'Carregador de alternador EcoFlow: 1,3 h',
            view_3_top_3: 'Tomadas tradicionais de 12 V para carros: 10 horas ou mais',
            view_3_top_4: '*Comparação do tempo necessário para carregar completamente 1 kWh',
            view_3_bottom_left_1: '3 em 1',
            view_3_bottom_left_2: 'Carregador rápido, mantenedor e auxiliar de partida',
            view_3_bottom_right: 'Controle Inteligente de Aplicativo',
        },
        DELTA_2: {
            title: 'Carregue totalmente com uma viagem de 1,3 horas',
            desc: 'Carregue enquanto dirige com a primeira inovação em carregadores de alternador do setor. Com um alternador turbo de 800 W, recarregue seu armazenamento de energia 8 vezes mais rápido do que usando uma tomada de 12 V tradicional. Recarregue 1 kWh em apenas 1,3 hora. Não é apenas um carregador mais rápido, ele mantém a saúde da bateria e funciona como um carregador auxiliar.',
            view_1: '<big>1,3 horas</big> para carregar 1 kWh',
            view_2_top: 'Alternador Turbocharge <big>800W</big>',
            view_2_bottom: 'Fácil instalação',
            view_3_top_1: '8× mais rápido',
            view_3_top_2: 'Carregador de alternador EcoFlow: 1,3 h',
            view_3_top_3: 'Tomadas tradicionais de 12 V para carros: 10 horas ou mais',
            view_3_top_4: '*Comparação do tempo necessário para carregar completamente 1 kWh',
            view_3_bottom_left_1: '3 em 1',
            view_3_bottom_left_2: 'Carregador rápido, mantenedor e auxiliar de partida',
            view_3_bottom_right: 'Controle Inteligente de Aplicativo',
        },
    },
    mx: {
        DELTA_PRO: {
            title: 'Recarga el 80% en un viaje de 3 horas',
            desc: 'Carga mientras conduces con el innovador cargador con alternador de la industria. Con un alternador turbo de 800 W, recarga tu batería 8 veces más rápido que con una toma de corriente tradicional de 12 V. Recarga 1 kWh en solo 1,3 horas. No solo es un cargador más rápido, sino que también mantiene la batería en buen estado y funciona como un arrancador.',
            view_1: '<big>1,3 horas</big>para cargar 1kWh',
            view_2_top: 'Alternador turboalimentado de 800 W',
            view_2_bottom: 'Fácil instalación',
            view_3_top_1: '8 veces más rápido',
            view_3_top_2: 'Cargador de alternador EcoFlow: 1,3 h',
            view_3_top_3: 'Tomacorrientes tradicionales de 12 V para automóvil: más de 10 horas',
            view_3_top_4: '*Comparación del tiempo necesario para cargar completamente 1kWh',
            view_3_bottom_left_1: '3 en 1',
            view_3_bottom_left_2: 'Cargador rápido, mantenedor y arrancador de batería',
            view_3_bottom_right: 'Control inteligente de aplicaciones',
        },
        DELTA_2_MAX: {
            title: 'Carga completa con un viaje de 2,6 horas',
            desc: 'Carga mientras conduces con el innovador cargador con alternador de la industria. Con un alternador turbo de 800 W, recarga tu batería 8 veces más rápido que con una toma de corriente tradicional de 12 V. Recarga 1 kWh en solo 1,3 horas. No solo es un cargador más rápido, sino que también mantiene la batería en buen estado y funciona como un arrancador.',
            view_1: '<big>1,3 horas</big>para cargar 1kWh',
            view_2_top: 'Alternador turboalimentado de 800 W',
            view_2_bottom: 'Fácil instalación',
            view_3_top_1: '8 veces más rápido',
            view_3_top_2: 'Cargador de alternador EcoFlow: 1,3 h',
            view_3_top_3: 'Tomacorrientes tradicionales de 12 V para automóvil: más de 10 horas',
            view_3_top_4: '*Comparación del tiempo necesario para cargar completamente 1kWh',
            view_3_bottom_left_1: '3 en 1',
            view_3_bottom_left_2: 'Cargador rápido, mantenedor y arrancador de batería',
            view_3_bottom_right: 'Control inteligente de aplicaciones',
        },
        DELTA_2: {
            title: 'Carga completa con un viaje de 1,3 horas',
            desc: 'Carga mientras conduces con el innovador cargador con alternador de la industria. Con un alternador turbo de 800 W, recarga tu batería 8 veces más rápido que con una toma de corriente tradicional de 12 V. Recarga 1 kWh en solo 1,3 horas. No solo es un cargador más rápido, sino que también mantiene la batería en buen estado y funciona como un arrancador.',
            view_1: '<big>1,3 horas</big>para cargar 1kWh',
            view_2_top: 'Alternador turboalimentado de 800 W',
            view_2_bottom: 'Fácil instalación',
            view_3_top_1: '8 veces más rápido',
            view_3_top_2: 'Cargador de alternador EcoFlow: 1,3 h',
            view_3_top_3: 'Tomacorrientes tradicionales de 12 V para automóvil: más de 10 horas',
            view_3_top_4: '*Comparación del tiempo necesario para cargar completamente 1kWh',
            view_3_bottom_left_1: '3 en 1',
            view_3_bottom_left_2: 'Cargador rápido, mantenedor y arrancador de batería',
            view_3_bottom_right: 'Control inteligente de aplicaciones',
        },
    },
};
